module.exports = __webpack_public_path__ + "public/SiteIcons/reservationPhone.svg?9d5ec9e8";